import PropTypes from 'prop-types'
import cn from '../modules/cn'

function OrderedList({ items }) {
  return items && (
  <ol
    className="space-y-3 list-decimal counter-reset-numList"
  >
    {items.map((item) => (
      <li
        key={item.props.id}
        className={cn(
          'relative ml-6 pl-2 before:left-[-1.5rem] before:w-[1.4rem] before:h-[1.4rem]',
          'before:float-left before:absolute before:bg-gray-400 before:rounded-full before:counter-increment-numList',
          'before:font-display before:font-extrabold before:text-sm before:text-center before:text-white before:h-6',
          'before:w-6 before:leading-6',
        )}
      >
        {item}
      </li>
    ))}
  </ol>
  )
}

OrderedList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.element).isRequired,
}

export default OrderedList
